import { Box } from "@mui/material";
import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import DataGridCustomToolbar from "components/DataGridCustomToolBar";
import DeleteLevelConfirmationDialog from "./deleteLevelConfirmationDialog";
import ReassignLevelDialog from "./reassignLevelDialog";
import { useLevelGrid } from "../hooks/useLevelGrid";

function LevelGrid({ handleEditOpen }) {
  const {
    backgroundAlt,
    primaryLight,
    page,
    setPage,
    pageSize,
    setPageSize,
    search,
    setSearch,
    sort,
    setSort,
    searchInput,
    setSearchInput,
    levels,
    totalLevels,
    deleteLevelDialogOpen,
    reassignDialogOpen,
    setReassignDialogOpen,
    handleDeleteLevelConfirm,
    closeDeleteDialog,
    handleReassignConfirm,
    columns,
  } = useLevelGrid({ handleEditOpen });

  return (
    <Box
      mt="40px"
      sx={{
        "& .MuiDataGrid-root": {},
        "& .MuiDataGrid-cell": {
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflow: "visible",
        },
        "& .MuiDataGrid-columnHeaders": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-virtualScroller": {
          backgroundColor: backgroundAlt,
        },
        "& .MuiDataGrid-footerContainer": {
          backgroundColor: primaryLight,
        },
        "& .MuiDataGrid-row": {
          height: "auto", // This ensures the row height adapts to content
        },
      }}
    >
      <DataGrid
        getRowId={(row) => row._id}
        rows={levels}
        columns={columns}
        page={page}
        pageSize={pageSize}
        rowCount={totalLevels}
        rowsPerPageOptions={[5, 10, 25, 50, 100]}
        onPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(newPageSize) => {
          setPage(0);
          setPageSize(newPageSize);
        }}
        paginationMode="server"
        components={{
          Toolbar: DataGridCustomToolbar,
        }}
        componentsProps={{
          toolbar: {
            search,
            setSearch,
            searchInput,
            setSearchInput,
            sort,
            setSort,
          },
        }}
        disableSelectionOnClick
        rowHeight={50}
        autoHeight
      />
      {/* Delete Confirmation Dialog */}
      <DeleteLevelConfirmationDialog
        open={deleteLevelDialogOpen}
        handleClose={closeDeleteDialog}
        handleDeleteLevelConfirm={handleDeleteLevelConfirm}
      />

      {/* Reassign Assessments Dialog */}
      <ReassignLevelDialog
        open={reassignDialogOpen}
        handleClose={() => setReassignDialogOpen(false)}
        handleReassignConfirm={handleReassignConfirm}
      />
    </Box>
  );
}

export default LevelGrid;
